import { faMagnifyingGlass } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { RecipeErpViewComponentProps } from 'components/desktop/ShoppingCart/Detail/Index';
import useTranslation from 'hooks/useTranslation';

interface IProps extends RecipeErpViewComponentProps {
	handleChange: (input: string) => void;
	value: string;
}

const SearchInput = (props: IProps) => {
	const { t } = useTranslation();
	return (
		<div className="input-group">
			<div className="input-group-prepend">
				<span className="input-group-text" id="basic-addon1">
					<FontAwesomeIcon icon={faMagnifyingGlass} style={{ marginRight: '6px' }} />
					{t('header:SEARCH')}
				</span>
			</div>
			<input
				type="text"
				className="form-control"
				placeholder="…"
				value={props.value}
				onChange={(e) => props.handleChange(e.target.value)}
			/>
		</div>
	);
};

export default SearchInput;
